import React from 'react';
import BuilderItemHeader from "./BuilderItemHeader";

const Thead = ({listaLabel, sortSel, setSortSel, listaItemsMeta}) => {
  
  
  const facHeader = BuilderItemHeader(sortSel, setSortSel);
  const listTH = listaLabel
    .map(k => facHeader(k))
    .map((k, index) => {
      
      const cssPorIndex = index === 0 ? "tdIndex" : ""
      const cssPorLabel = k === "" ? "" : "cursorPointer"
      
      const iconSort = k.isSel && k.label !== "" ? (
        sortSel.isAsc ? <i className="fa fa-chevron-circle-up m5L "/> : <i className="fa fa-chevron-circle-down m5L"/>
      ) : null;
      
      //metas
      const meta = listaItemsMeta.find(m => k.label === m.label)
      
      let styleMeta = meta?.style;
      
      return (
        <th className={cssPorIndex + " " + cssPorLabel}
            onClick={k.onClick}
            key={index}
            style={styleMeta}
        >
          {k.label} {iconSort}
        </th>
      );
    })
  ;
  
  
  return (
    <thead>
    <tr>
      {listTH}
    </tr>
    </thead>
  );
};

export default Thead